import type { FetchError } from 'ofetch';

export const useBannerNotificationsStore = defineStore('bannerNotifications', () => {
  const {
    getAllBannerNotifications,
    getActiveBannerNotifications,
    createBannerNotification,
    updateBannerNotification,
  } = useApi().v2;
  const bannerNotifications = ref<BannerNotification[]>([]);
  const activeBannerNotifications = ref<BannerNotification[]>([]);
  const bannerNotificationsPage = ref(1);
  const bannerNotificationsPerPage = ref(10);
  const bannerNotificationsSortBy = ref<PaginationSortBy>({
    key: 'last_name',
    order: 'asc',
  });
  const bannerNotificationsCount = ref(0);
  const bannerNotificationsLoading = ref(false);

  /**
   * Fetches a page of the bannerNotifications from the server and populates the store.
   * If the `forceRefresh` argument is set to true, then the related roles
   * are always re-requested. Otherwise, the last retrieved value will be
   * returned if one exists.
   *
   * @param options.page
   * @param options.itemsPerPage
   * @param options.sortBy
   * @param forceRefresh
   */
  const fetchBannerNotifications = async (options: DataTableOptions & UserFilters) => {
    // TODO options diffing for proper forceRefresh logic (should only need forcing if the request uses the same options twice)
    bannerNotificationsLoading.value = true;

    const {
      page,
      itemsPerPage,
      sortBy,
    } = options;

    // Update page and itemsPerPage from options provided
    bannerNotificationsPage.value = page;
    bannerNotificationsPerPage.value = itemsPerPage;

    const apiOptions: PageFilters = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };

    /**
     * Convert the first VDataTableServer sortBy option into Django's "order_by" param
     * and store the sortBy option provided.
     */
    if (sortBy[0]) {
      apiOptions.order_by = `${sortBy[0].order === 'desc' ? '-' : ''}${sortBy[0].key}`;
      bannerNotificationsSortBy.value = sortBy[0];
    }

    const { count, results } = await getAllBannerNotifications(apiOptions);
    bannerNotificationsCount.value = count;
    bannerNotifications.value = results;
    bannerNotificationsLoading.value = false;
  };

  const fetchActiveBannerNotifications = async (forceRefresh = false) => {
    if (!forceRefresh && activeBannerNotifications.value.length > 0) {
      return;
    }

    try {
      // await getActiveBannerNotifications();
      activeBannerNotifications.value = (await getActiveBannerNotifications()).results;
      // activeBannerNotifications.value = [];
    }
    catch (err) {
      console.error('Error fetching active banner notifications:', (err as FetchError).message);
    }
  };

  return {
    activeBannerNotifications,
    bannerNotifications,
    bannerNotificationsCount,
    bannerNotificationsLoading,
    bannerNotificationsPage,
    bannerNotificationsPerPage,
    bannerNotificationsSortBy,
    fetchActiveBannerNotifications,
    fetchBannerNotifications,
  };
});
